import React, { useEffect, useState } from "react";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import ProductCard from "../ProductCard";
import styled from "styled-components";
import { supabase } from "../../client";

const ProductSection = ({ addToCart, cart }) => {
  const [product, setProduct] = useState([]);
  const [tab, setTab] = useState("featured");

  const getProduct = async (e) => {
    const products = (await supabase.from("products").select().limit(10)).data;
    setProduct(products);
  };

  useEffect(() => {
    getProduct();
    console.log(tab);
  }, [tab]);
  return (
    <LargeContainer
      style={{
        flexDirection: "column",
        marginTop: "6em",
      }}
      valign="center"
    >
      <MainContainer>
        <SectionHeading>OUR PRODUCTS</SectionHeading>
      </MainContainer>
      <MainContainer style={{ marginTop: "2em" }}>
        <Tab
          className={tab === "featured" && "active"}
          onClick={() => {
            setTab("featured");
          }}
        >
          Featured
        </Tab>
        <Tab
          className={tab === "bestseller" && "active"}
          onClick={() => setTab("bestseller")}
        >
          Bestseller
        </Tab>
        <Tab
          className={tab === "latest" && "active"}
          onClick={() => setTab("latest")}
        >
          Latest
        </Tab>
      </MainContainer>
      <MainContainer style={{ marginTop: "2em" }}>
        {product.map((p) => (
          <ProductCard
            key={p.id}
            product={p}
            addToCart={addToCart}
            cart={cart}
            width="25%"
          />
        ))}
      </MainContainer>
    </LargeContainer>
  );
};
const SectionHeading = styled.div`
  font-size: 2em;
  font-weight: 700;
  color: #393939;
  display: flex;
  align-items: center;
  padding: 1rem;
  ::before,
  ::after {
    margin: 0 1rem;
    content: " ";
    width: 72px;
    height: 2px;
    background-color: #83aa4c;
  }
`;
const Tab = styled.div`
  padding: 0.8em 1.5em;
  margin: 1em;
  color: #393939;
  text-decoration: none;
  border: 1px solid #d8d6d6;
  border-radius: 0.25em;
  transition: color 0.5s, border 0.5s;
  &.active {
    color: #83aa4c;
    border: 1px dashed #83aa4c;
  }
  :visited {
    color: #393939;
  }
  :hover {
    color: #83aa4c;
    border: 1px dashed #83aa4c;
  }
`;
export default ProductSection;
